<template>
  <footer  class="goenroll-footer" :class="((this.$route.name === 'main') || (this.$route.name === 'information')) ?  'goenroll-footer' : 'transparent-footer'">
    <ul>
      <li><a @click="routeToPages('/')">Home</a></li>
      <li>
        <a @click="goToSection('/information', 'copyright')"
          >Copyright Information</a
        >
      </li>
      <li>
        <a @click="goToSection('/information', 'privacy')"
          >Privacy Statements</a
        >
      </li>
      <li>
        <a @click="goToSection('/information', 'disclaimers')">Disclaimers</a>
      </li>
      <li>
        <a @click="goToSection('/information', 'terms')"
          >Terms and Conditions</a
        >
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: "GoenrollFooter",
  props: {
    goToSection: {
      type: Function,
      required: true,
    },
  },
  computed: {
    landingInfo() {
      return this.$store?.getters?.getLandingInfo
    },
  },
  methods: {
    routeToPages(path) {
      this.$router.push(path);
    }
  },
};
</script>

<style >
.goenroll-footer {
  text-align: center;
  background: #ffffff;
  border-top: 1px solid #eaeaea;
}
.goenroll-footer.transparent-footer {
  background: transparent;
}
.goenroll-footer ul li {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 500;
  color: #006cb0;
  border-right: 0px !important;
}
.goenroll-footer ul li a {
  color: #006cb0;
}
.goenroll-footer ul li a:hover {
  color: #1c85c7;
}
</style>
